import { apiBase, fetchUsingApi } from "../core/apiClient";
import { ApiResponse } from "../core/types";
import { NotificationSettings } from "../models/notification";

// Fetch notification settings from API
export const fetchNotificationSettings = async (): Promise<ApiResponse<NotificationSettings>> => {
  return await fetchUsingApi(`${apiBase}/api/v1/notifications/settings`, "GET", (data) => data as NotificationSettings);
};

// Update notification settings
export const updateNotificationSettings = async (
  settings: NotificationSettings,
): Promise<ApiResponse<NotificationSettings>> => {
  return await fetchUsingApi(
    `${apiBase}/api/v1/notifications/settings`,
    "PUT",
    (data) => data as NotificationSettings,
    JSON.stringify(settings),
  );
};
